module.exports = __webpack_public_path__ + "img/TravelersOneBag.0a91d42e.png";